import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loader } from 'semantic-ui-react';
import ProductItem from '../products/item.js';
import { doGetEquipmentProductList } from '../../actions/equipment-actions.js';
import './equipment-product-list.css';

export class EquipmentProductList extends React.PureComponent {
  componentDidMount() {
    this.fetchIfNeeded();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.equipmentId !== this.props.equipmentId) {
      this.fetchIfNeeded();
    }
  }

  fetchIfNeeded() {
    const { equipmentId, locationId, productList } = this.props;
    if (equipmentId && locationId && (!productList || (!productList.loading && !productList.products.length))) {
      this.props.actions.doGetEquipmentProductList({
        location_id: locationId,
        equipment_id: equipmentId,
      });
    }
  }

  render() {
    const { productList } = this.props;

    if (!productList || productList.loading) {
      return (
        <div className="equipment-product-list loading">
          <Loader active inline="centered" size="small" />
        </div>
      );
    }

    if (!productList.products.length) {
      return (
        <div className="equipment-product-list empty">
          <p>No suggested products for this equipment.</p>
        </div>
      );
    }

    const heading = this.props.equipmentName
      ? `${this.props.equipmentName} — ${productList.list_name || 'Products'}`
      : productList.list_name;

    return (
      <div className="equipment-product-list">
        {heading && <h4 className="product-list-name">{heading}</h4>}
        <div className="equipment-products-grid">
          {productList.products.map((product) => (
            <ProductItem key={product.id} item={product} canFavorite={false} />
          ))}
        </div>
      </div>
    );
  }
}

EquipmentProductList.propTypes = {
  equipmentId: PropTypes.number.isRequired,
  equipmentName: PropTypes.string,
  locationId: PropTypes.number,
  productList: PropTypes.shape({
    loading: PropTypes.bool,
    products: PropTypes.array,
    list_name: PropTypes.string,
  }),
  actions: PropTypes.shape({
    doGetEquipmentProductList: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state, props) {
  return {
    locationId: state.locations.open.id,
    productList: state.equipment.productLists[props.equipmentId],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ doGetEquipmentProductList }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentProductList);
